import React from 'react';
import { Box, ButtonBase, CardContent, Typography } from '@mui/material';
import LinkIcon from '@mui/icons-material/Link';
import EditNoteIcon from '@mui/icons-material/EditNote';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { useAppContext } from '../context/AppContext';

const OPTIONS = [
  {
    value: 'connect',
    icon: <LinkIcon />,
    title: 'Fetch my investments',
    description: 'Securely pull mutual funds, stocks, NPS and bank balances via MF Central and Account Aggregator.',
  },
  {
    value: 'manual',
    icon: <EditNoteIcon />,
    title: 'Enter manually',
    description: 'Type in totals for bank balances, deposits, mutual funds, equity and other assets.',
  },
];

function InvestmentJourney() {
  const { state, actions } = useAppContext();

  return (
    <Box>
      <CardContent>
        <Typography variant="h6" sx={{ mb: 1, color: 'primary.main' }}>
          Your Investments
        </Typography>
        <Typography variant="body1" sx={{ mb: 3 }}>
          How would you like to add your current investments?
        </Typography>

        <Box role="radiogroup" aria-label="Choose how to add your investments" sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          {OPTIONS.map((opt) => {
            const selected = state.investmentJourney === opt.value;
            return (
              <ButtonBase
                key={opt.value}
                role="radio"
                aria-checked={selected}
                onClick={() => actions.updateFormData('investmentJourney', opt.value)}
                sx={{
                  display: 'flex',
                  alignItems: 'flex-start',
                  gap: 2,
                  p: 2,
                  textAlign: 'left',
                  border: '1px solid',
                  borderColor: selected ? '#000' : 'grey.300',
                  bgcolor: selected ? 'grey.100' : 'background.paper',
                  borderRadius: 1,
                  '&:focus-visible': { outline: '3px solid #FFD700', outlineOffset: '2px' },
                }}
              >
                <Box sx={{ mt: 0.25 }}>{opt.icon}</Box>
                <Box sx={{ flex: 1 }}>
                  <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>{opt.title}</Typography>
                  <Typography variant="body2" color="text.secondary">{opt.description}</Typography>
                </Box>
                {selected && <CheckCircleIcon fontSize="small" aria-hidden="true" />}
              </ButtonBase>
            );
          })}
        </Box>
      </CardContent>
    </Box>
  );
}

export default InvestmentJourney;
